import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  var mp = '@meda print';
  return {
    info: _defineProperty({
      padding: "".concat(componentTheme.infoPaddingTopBottom, " ").concat(componentTheme.infoPaddingLeftRight),
      backgroundColor: componentTheme.infoBackgroundColor,
      height: '100%'
    }, mq, {
      padding: componentTheme.phoneInfoPadding
    }),
    header: {
      paddingTop: componentTheme.headerPaddingTop,
      paddingBottom: componentTheme.headerPaddingBottom,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    title: {
      fontSize: componentTheme.titleFontSize,
      fontWeight: componentTheme.titleFontWeight
    },
    jumpToItems: _defineProperty({}, mp, {
      display: 'none'
    })
  };
};
export default generateStyle;